import { render, staticRenderFns } from "./AssignEmployeeModal.vue?vue&type=template&id=2d1359ec&scoped=true"
import script from "./AssignEmployeeModal.vue?vue&type=script&lang=js"
export * from "./AssignEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./AssignEmployeeModal.vue?vue&type=style&index=0&id=2d1359ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1359ec",
  null
  
)

export default component.exports